import config from '@/api/config'

let subUrlRus = '/russianpost'
let subUrlCdek = '/cdek'
let subUrlPek = '/pek'

export default {
  calcRussPost: {
    url: function () {
      return config.baseUrl + config.version2 + subUrlRus + '/calculate'
    }
  },
  calcCDEK: {
    url: function () {
      return config.baseUrl + config.version2 + subUrlCdek + '/calculate'
    }
  },
  calcPEK: {
    url: function () {
      return config.baseUrl + config.version2 + subUrlPek + '/calculate'
    }
  },
}
